import { useEffect, useState } from "react";

/**
 * This hook tracks how far the top of an element is from the top of a document. It
 * is used when selecting a new page in the <Pagination> component to scroll the user
 * to the top of the new page.
 */
export default (
  scrollToRef: React.RefObject<HTMLDivElement | null>
): number => {
  const [scrollTop, setScrollTop] = useState(0);
  useEffect(() => {
    if (typeof window === "undefined") return;
    const onResize = () =>
      setScrollTop(
        Math.round(
          (scrollToRef.current?.getBoundingClientRect().top ?? 0) +
            document.documentElement.scrollTop
        )
      );
    window.addEventListener("resize", onResize);
    onResize();
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return scrollTop;
};
